// extracted by mini-css-extract-plugin
module.exports = {"heading__container":"header_heading__container__FDqHK"};